import React from 'react'
import { useState, useEffect } from 'react';
import dashes from '../../../../images/dashes.svg'
import profile2 from '../../../../images/profile-2.svg'
import { FaArrowRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { Alert, Image } from 'react-bootstrap';

const DashboardAlert = () => {
    const [showAlert, setShowAlert] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowAlert(false);
    }, 10000);

    return () => clearTimeout(timeout);
  }, []);


  return (
    
    <Alert className={showAlert ? 'alert' : 'hidden'}>
    <Image fluid src={dashes} className='mx-xl-5 px-xl-5'/>
    <div className='d-flex justify-content-between align-items-center mt-3'>
      <img src={profile2}/>
      <p className='alert-info ms-4'>Take a second to edit your resume to increase your application success rate </p>
      <Link to='/jobseekerprofile'><FaArrowRight className='' style={{width: '50px',
      height: '30px'}}/></Link>
    </div>
    </Alert>
    // <div className={showAlert ? 'alert' : 'hidden'}>
    //   <img src={dashes}/>
    //   <div className='alert-info'>
    //     <img src={profile2}/>
    //     <p>Take a second to edit your resume to increase your application success rate </p>
    //     <Link to='/jobseekerprofile'><FaArrowRight className='arrow'/></Link>
    //   </div>
    // </div>
  )
}

export default DashboardAlert